import {Colors} from "@bounce/shared/ui";
import {ChipVariant} from "../templates/templateDisplay";
import {
  ReachTemplateContentChannel,
  ReachTemplateLanguage,
  TemplateTriggerReference,
} from "../../apis/requests/templates/types";
import {
  TriggerInteractionType,
  TriggerOperator,
  TriggerStatus,
  TriggerTiming,
} from "../../apis/requests/triggers/types";

export type TextKind = "sms" | "mms";

export const TEXT_KIND_CHANNELS: Record<TextKind, ReachTemplateContentChannel[]> = {
  sms: ["sms", "sms_with_landing_page"],
  mms: ["mms", "mms_with_landing_page"],
};

export const TEMPLATE_SLOT_CHANNELS: Record<TemplateTriggerReference["slot"], ReachTemplateContentChannel[]> = {
  email: ["email"],
  text: [...TEXT_KIND_CHANNELS.sms, ...TEXT_KIND_CHANNELS.mms],
};

export const LANGUAGE_OPTIONS: {value: ReachTemplateLanguage; label: string}[] = [
  {value: "en", label: "EN"},
  {value: "es", label: "ES"},
];

export const TRIGGER_STATUS_DISPLAY: Record<TriggerStatus, {label: string; variant: ChipVariant; dotColor: string}> = {
  active: {label: "Active", variant: "success", dotColor: Colors.neon._700},
  draft: {label: "Draft", variant: "inherit", dotColor: Colors.grey._400},
  paused: {label: "Paused", variant: "warning", dotColor: Colors.orange._600},
};

export const TIMING_DISPLAY: Record<TriggerTiming, {label: string; shortLabel: string; description?: string}> = {
  immediately: {label: "Send immediately", shortLabel: "Immediate"},
  working_hours: {
    label: "Working hours only",
    shortLabel: "Working hours only",
    description: "Held until 08:00–21:00 in the account's state.",
  },
};

export const LOCKED_CONDITION_HINT = "Locked so it isn't changed by mistake. Click to unlock it.";

export const OWN_PAYMENT_INTERACTION_TYPES: ReadonlySet<TriggerInteractionType> = new Set([
  "PAYMENT_FAILURE",
  "PAYMENT_SUCCESS",
]);

export const TRIGGER_MONEY_PARAMETERS: ReadonlySet<string> = new Set(["amount", "remaining_balance"]);

export const OPERATOR_LABELS: Record<TriggerOperator, string> = {
  equals: "=",
  not_equals: "≠",
  includes: "includes",
  in: "in",
  not_in: "not in",
  is_true: "is true",
  is_false: "is false",
  is_null: "is empty",
  is_not_null: "is not empty",
  gt: ">",
  gte: "≥",
  lt: "<",
  lte: "≤",
};

export const NO_VALUE_OPERATORS = new Set<string>(["is_true", "is_false", "is_null", "is_not_null"]);
